import React from 'react';
import { LoadingCta } from './cta.component';
import { StatCard } from './stat-card.component';
import { LoadingBanner } from './banner.component';
import { LoadingGeneric } from './generic.component';
import { LoadingList } from './list.component';

// const variants = ['cta', 'statCard', 'banner', 'generic'];

type OwnProps = {
  variant?: any; // TODO: oneOf(variants)
};

// @ts-expect-error ts-migrate(2456) FIXME: Type alias 'Props' circularly references itself.
type Props = OwnProps & typeof LoadingModule.defaultProps;

export const LoadingModule = (props: Props) => {
  switch (props.variant) {
    case 'cta':
      return <LoadingCta {...props} />;
    case 'statCard':
      return <StatCard {...props} />;
    case 'banner':
      return <LoadingBanner {...props} />;
    case 'list':
      return <LoadingList {...props} />;
    case 'generic':
    default:
      return <LoadingGeneric {...props} />;
  }
};

LoadingModule.defaultProps = {
  variant: 'generic',
};
